import React, { Component } from 'react';
import { connect } from 'react-redux';
import ErrorBoundary from '../../../../components/ErrorBoundary';
import HelpButton from '../../../../components/HelpButton';
import PbxVirtualOperator from './PbxVirtualOperator';
import PbxVirtualOperatorCustomerOpening from './PbxVirtualOperatorCustomerOpening';
import PbxVirtualOperatorCustomerFestivities from './PbxVirtualOperatorCustomerFestivities';
import {
  fetchEnterpriseDataRequest,
  fetchVirtualOperatorMessagesRequest,
  fetchVirtualOperatorSettingsRequest
} from '../../../../js/virtualOperator/actions';
import PbxVirtualOperatorCustomerInfo from './PbxVirtualOperatorCustomerInfo';
import { 
  isEnterpriseInfoError,
  isEnterpriseInfoLoaded,
  isFetchSettingsError,
  isFetchSettingsLoaded
} from '../../../../js/virtualOperator/selectors';
import GlobalErrorPage from '../../../pages/GlobalErrorPage';
import Loading from '../../../../components/Loading';
import PbxVirtualOperatorCustomerWelcome from './PbxVirtualOperatorCustomerWelcome';

class PbxVirtualOperatorCustomerPage extends Component {
  componentDidMount() {
    this.props.fetchInfo();
    this.props.fetchSettings();
    const params = {
      name: null,
    };
    this.props.fetchMessages(params);
  }

  render() {
    const {
      loaded,
      error
    } = this.props;
    return (
      <PbxVirtualOperator scrolling>
        <div className="text-right">
          <HelpButton fileName="virtual-operator-customer" />
        </div>
        <ErrorBoundary>
          <React.Suspense fallback={<div />}>
            {loaded ? (
              error ? (
                <GlobalErrorPage />
              ) : (
                <React.Fragment>
                  <PbxVirtualOperatorCustomerWelcome {...this.props} />
                  <PbxVirtualOperatorCustomerOpening {...this.props} />
                  <PbxVirtualOperatorCustomerFestivities {...this.props} />
                  <PbxVirtualOperatorCustomerInfo {...this.props} />
                </React.Fragment>
              )
            ) : (
              <Loading />
            )}
          </React.Suspense>
        </ErrorBoundary>
      </PbxVirtualOperator>
    );
  }
}



function mapStateToProps(state) {
  return {
    loaded: isEnterpriseInfoLoaded(state) && isFetchSettingsLoaded(state),
    error: isEnterpriseInfoError(state) || isFetchSettingsError(state),
  };
}

export default connect(mapStateToProps, {
  fetchMessages: fetchVirtualOperatorMessagesRequest,
  fetchInfo: fetchEnterpriseDataRequest,
  fetchSettings: fetchVirtualOperatorSettingsRequest,
})(PbxVirtualOperatorCustomerPage);
